module.exports = __webpack_public_path__ + "media/images/icons/icon_menu_sp-2d9a978016b15fc8e4d39b863ff650b9.svg";